export const termsTranslations = {
  TERMS_TITLE: 'Algemene voorwaarden',
  TERMS_SUBTITLE: 'versie',
};
